import React, {Component} from "react";
import {Box, LinearProgress} from "@mui/material";

class LoadingBarComponent extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            loading: false
        };
    }

    // callEvent(create) {
    //     // console.log("Event-------------" + create)
    //     this.setState({loading: true}, function () {
    //         console.log("State ")
    //         console.log(this.state.loading);
    //     });
    // }

    // handleLoadingEvent = event => {
    //     console.log("EVENT -------------------------------------");
    //     console.log(event);
    // }
    //
    // componentDidMount() {
    //     console.log("componentDidMount");
    //     window.addEventListener('loadEvent', this.handleLoadingEvent);
    //     console.log("Listen Events");
    //
    // }
    //
    // componentWillUnmount() {
    //     console.log("componentWillUnmount");
    //     window.removeEventListener('loadEvent', this.handleLoadingEvent);
    // }
    //
    // static getDerivedStateFromError(error) {
    //     return console.log(error);
    // }

    render() {
        return (
            <Box sx={{width: '100%'}}>
                {this.state.loading ? <LinearProgress color={"secondary"}/> : null}
            </Box>
        );
    }
}

export default LoadingBarComponent;